module.exports = __webpack_public_path__ + "static/media/4.fd9df0a2.svg";